<template>
  <div v-if="isConnected">
    <div v-if="sheriff">
      <h2 class="text-center mt-2">{{sheriff.id.label}}</h2>
      <div class="form-group text-right mr-2 mt-1">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="listaElevador" v-model="modoView">
          <label class="custom-control-label" for="listaElevador">{{$t('message.viewMode')}}</label>
        </div>
      </div>
      <sheriff-view-elevador v-if="!modoView"/>
      <sheriff-view-lista v-else/>
    </div>
    <div v-else>
      <!-- <div class="jumbotron mt-4">
        <h3>{{ $t("message.selectUp") }}</h3>
      </div>-->
      <div class="row mt-2 mx-0 overflow-hidden">
        <div
          class="col-12 col-lg-6 col-xl-4 px-1 flex-fill"
          v-for="sheriff of sheriffs"
          :key="sheriff.id.address"
        >
          <div class="card text-white mb-1" style="background-color: transparent !important">
            <div class="card-header clickable" @click="selecionarSheriff(sheriff.id.address)">
              <h3>{{sheriff.id.label}}</h3>
            </div>
            <div class="card-body fix-padding-card-body">
              <sheriff-elevador-responsive-image :sheriff="sheriff"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="alert alert-danger mt-2">
      <h1>
        {{$t('message.noConnection')}}
        <span v-html="pensando"></span>
      </h1>
    </div>
  </div>
</template>

<script>
import SheriffViewLista from "../sheriff-view-lista/SheriffViewLista";
import SheriffViewElevador from "../sheriff-view-elevador/SheriffViewElevador";
import SheriffElevadorResponsiveImage from "../sheriff-view-elevador/SheriffElevadorResponsiveImage";
import { mapGetters, mapState } from "vuex";

let reticencias = [" ", ".", ". .", ". . ."];
export default {
  name: "SheriffHome",
  data() {
    return {
      modoView: true
    };
  },
  methods: {
    selecionarSheriff(endereco) {
      this.$store.dispatch("selecionarSheriff", endereco);
      this.$router.push("/");
      document.querySelector("#sheriff-select").value = endereco;
    }
  },
  components: {
    SheriffViewLista,
    SheriffViewElevador,
    SheriffElevadorResponsiveImage
  },
  computed: {
    ...mapGetters(["isConnected", "getTentativas"]),
    ...mapState(["sheriff", "sheriffs"]),
    pensando() {
      return reticencias[this.getTentativas % 4];
    }
  }
};
</script>

<style>
.fix-padding-card-body {
  padding: 0;
  padding-top: 1.25rem;
}
.card-header {
  text-transform: uppercase;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
</style>
